import { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { openMessageAfter, tl } from '../../lib/whatsapp';
import { fillTemplate } from '../../lib/messageTemplates';
import { RUNTIME_BACKEND_URL } from '../../lib/backendUrl';

// Teklifi WhatsApp ile gönder; isteğe bağlı müşteri linki (görüntüle / PDF / onayla) eklenir
export const TeklifShareButton = ({ row, token, template, firma }) => {
  const [open, setOpen] = useState(false);
  const [withLink, setWithLink] = useState(true);

  const send = async () => {
    try {
      await openMessageAfter('whatsapp', async () => {
        let link = '';
        if (withLink) {
          const r = await fetch(`${RUNTIME_BACKEND_URL}/api/hesap/teklif/${row.id}/share`, { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
          if (!r.ok) throw new Error('Link oluşturulamadı');
          link = `Teklifi görüntülemek ve onaylamak için: ${window.location.origin}/teklif/${(await r.json()).token}`;
        }
        const text = fillTemplate(template, {
          musteri: row.customer_name, teklif_no: row.teklif_no, toplam: tl(row.total), link, firma,
          tarih: row.date ? new Date(row.date).toLocaleDateString('tr-TR') : '-',
        });
        return { phone: row.customer_phone, text };
      });
      setOpen(false);
    } catch (e) { toast.error(e.message); }
  };

  return (
    <>
      <button type="button" onClick={() => setOpen(true)} title="Teklifi WhatsApp ile gönder" data-testid={`teklif-wa-${row.id}`}
        className="inline-flex items-center rounded-lg bg-[#25D366] hover:bg-[#1ebe5b] text-white p-1.5 transition-colors">
        <MessageCircle className="h-4 w-4" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm">
          <DialogHeader><DialogTitle>Teklifi WhatsApp ile gönder</DialogTitle></DialogHeader>
          <p className="text-sm text-muted-foreground">{row.customer_name} · {row.teklif_no} · {tl(row.total)}</p>
          <label className="flex items-start gap-2 text-sm cursor-pointer rounded-lg border p-3" data-testid="teklif-link-toggle">
            <input type="checkbox" checked={withLink} onChange={e => setWithLink(e.target.checked)} className="mt-0.5 accent-emerald-600" />
            <span><b>Teklif linkini ekle</b><br /><span className="text-xs text-muted-foreground">Müşteri teklifi şık bir sayfada görür, PDF indirir ve "Onaylıyorum / Reddediyorum" diye yanıtlayabilir.</span></span>
          </label>
          <Button onClick={send} className="bg-[#25D366] hover:bg-[#1ebe5b] text-white" data-testid="teklif-wa-send-btn">
            <MessageCircle className="h-4 w-4 mr-2" /> WhatsApp'ı Aç
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
};
